<ion-content class="ion-padding">
    <h4>{{ 'users.individualRule' | translate | uppercase }}</h4>

    <ion-item>
        <ion-label position="stacked">
        {{ 'generic.cycle' | translate }}*
        </ion-label>
        <ion-select [(ngModel)]="selectedCycle">
            <ion-select-option *ngFor="let cycle of cycles"
                [value]="cycle.id" >
                {{cycle.name}}
            </ion-select-option>
        </ion-select>
    </ion-item>
    <br>
    <ion-item *ngIf="selectedCycle">
        <ion-label position="stacked">
        {{ 'visibilityRules.userToBeViewed' | translate }}*
        </ion-label>
        <ion-input
            [placeholder]="'generic.searchByName' | translate"
            (keyup)='onChangeSearch($event)'
        ></ion-input>
        
        <ion-button (click)="addGroup()" mode="ios">
            Adicionar Lote
        </ion-button>
    </ion-item>
    <ion-list class="users" >
        <ion-item *ngFor="let user of users; let i = index;" >
            <p class="user" (click)="selectUser(i)" >
                <b>{{ user.name }}</b> - {{ user.attribute1 }}, {{ user.attribute2 }}<br>
            </p>
        </ion-item>
    </ion-list>
    <div class="users" *ngFor="let user of userRules; let i = index;">
        <div class="user" >
        <img [src]="getImageUrl(user.imageUrl)" default="" />
        <p class="name" >
            {{ user.name }}<br>
            <span>{{ user.businessGroup }} - {{ user.rank }} - {{ user.cycleName }}</span>
        </p>
        <p class="dismiss" (click)="removeUser(i)" >
            X
        </p>
        </div>
    </div>
</ion-content>
  
<ion-footer mode="ios">
    <ion-toolbar mode="ios">
        <ion-row>
        <ion-col size="4">
            <ion-button color="secondary" expand="block" mode="ios"
            (click)="dismiss()" >
            {{ 'generic.goBack' | translate }}
            </ion-button>
        </ion-col>
        <ion-col size="8">
            <ion-button color="primary" expand="block" mode="ios"
            (click)="save()" >
            {{ 'generic.save' | translate }}
            </ion-button>
        </ion-col>
        </ion-row>
    </ion-toolbar>
</ion-footer>